<script>
    import {mapActions, mapGetters, mapState} from "vuex";
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";

    export default {
        name: "CourseEnrollComponent",
        mixins: [AnimationsMixin],
        data () {
            return {
                componentType: 'course-enroll',
                rendersWithVue: true
            }
        },
        computed: {
            ...mapGetters('user', [
                'isAdmin',
                'isLoggedIn'
            ]),
            ...mapState('products', [
                'courses',
                'fetchingCourseContents',
            ]),
            ...mapState([
                'mobileClient',
                'mobileSettings',
                'subscriptionMode'
            ]),
            buttonOptions () {
                let options = {
                    status: 'hide', // status can be: hide, continue, subscribe, enroll, multiple
                    link: '#', // not used anywhere, just keeping it cause we had it previously
                };

                if (!this.myCourseData) {
                    return options; // return default options
                }

                const isEnrolled = false; // todo: temp solution for testing
                if (typeof this.mobileClient !== 'undefined' && this.mobileClient && !this.isFreeCourse && !this.mobileSettings.mobile_allow_purchase && !isEnrolled) {
                    options.status = 'hide';
                } else if (this.isDraftCourse) {
                    options.status = 'showcase-button';
                } else if (this.isUserAnAuthor && this.myCourseData.me && this.myCourseData.me.last_video_id && !this.isInAuthoringMode) {
                    options.status = 'continue';
                } else if (  this.myCourseData.me && ((this.myCourseData.me.registered && this.isFreeCourse) || (this.myCourseData.me.premium && this.isPaidCourse)) && !this.isInAuthoringMode) {
                    // Show normal continue only outside of authoring
                    options.status = 'continue';
                } else if (this.isPublicCourse && !this.isFreeCourse && this.subscriptionMode) {
                    options.status = 'subscribe';
                } else if (this.isPublicCourse ) {
                    if (this.buttonHasMultipleOptions && !this.isFreeCourse) {
                        options.status = 'multiple';
                    } else {
                        options.status = 'enroll';
                    }
                }

                return options;
            },
            getCourseEnrollLayout () {
                return 'CourseEnrollLayout1';
            },
            myCourseData () {
                let courseFound = null;

                this.courses.map(course => {
                    if (course.titleId === this.selectedCourseTitleId) {
                        courseFound = course;
                    }
                });

                return courseFound;
            },
            selectedCourseTitleId () {
                //when set directly on the component
                if (this.componentData.selectedCourseTitleId) {
                    return this.componentData.selectedCourseTitleId;
                }

                //when in course overview section
                if (this.hasContext('course-overview-section')) {
                    const sectionNodeState = this.findNodeState(this.sectionId);
                    return sectionNodeState ? sectionNodeState.getSelectedCourse() : "";
                }

                //when in course page
                if (this.isPageContext('course') && this.pageContext.params && this.courses.filter( course => course.titleId === this.pageContext.params.slug).length ) {
                    return this.pageContext.params.slug;
                }

                return "";
            },
            renderData () {
                let selectedCourseTitleId = this.selectedCourseTitleId;

                if (selectedCourseTitleId && this.fetchingCourseContents.indexOf(selectedCourseTitleId) === -1 &&
                    (!this.myCourseData || (this.myCourseData && typeof this.myCourseData.sections === "undefined")) //checking sections to see if getCourseContents has been fetched with the author getParam
                ) {
                    this.getCourseContentsData(selectedCourseTitleId);
                }

                let courseData = this.editCourseData(this.myCourseData);

                let renderData = {
                    course: courseData,
                    ...this.componentData
                };
                // console.log("buttonOptions : " , this.buttonOptions)
                return renderData;
            },
            isDraftCourse () {
                return this.myCourseData.access === 'private';
            },
            isFreeCourse () {
                return this.myCourseData.status === 'free';
            },
            isPaidCourse () {
                return this.myCourseData.status === 'paid';
            },
            isPublicCourse () {
                return this.myCourseData.access === 'public';
            },
            isInAuthoringMode () {
                return !(typeof window.authoringMode === 'undefined' || !window.authoringMode);
            },
            buttonHasMultipleOptions () {
                const courseHasMultipleOptions = this.renderData.course.hasPaymentPlans || this.renderData.course.hasSubscriptions || this.renderData.course.hasBundles;
                const buttonMultipleOptionsEnabled = this.myCourseData?.enrollButtonAllOptions;
                return courseHasMultipleOptions && buttonMultipleOptionsEnabled;
            },
            isUserAnAuthor () {
                return typeof window.me.meli !== 'undefined' && window.me.meli % 2 === 0;
            }

        },
        methods: {
            ...mapActions('products', [
                'getCourseContents'
            ]),
            getCourseContentsData (selectedCourseTitleId) {
                this.getCourseContents({courseId: selectedCourseTitleId, getParams: "author"});
            },
            getSelectedCourse () {
                return this.selectedCourseTitleId;
            },
            setSelectedCourse (eventData) {
                this.changeMyData({
                    selectedCourseTitleId: eventData.value
                });
                this.setChangesAreSaved(false);
            },
            editCourseData (courseData) {
                if (!courseData) {
                    return {};
                }
                let clonedData = copyJson(courseData);


                clonedData.hasPaymentPlans = typeof clonedData.paymentPlans !== 'undefined' && clonedData.paymentPlans.length ? true : false;
                clonedData.hasBundles = typeof clonedData.bundles !== 'undefined' && clonedData.bundles.length ? true : false;
                clonedData.hasSubscriptions = typeof clonedData.subscriptions !== 'undefined' && clonedData.subscriptions.length ? true : false;

                if (clonedData.hasPaymentPlans) {
                    //Set PaymentPlans Url
                    clonedData.paymentPlans.map((plan) => {
                        plan.url = '/payment?product_id=' + clonedData.titleId + '&plan_id=' + plan.id;
                        plan.totalAmount = plan.firstAmount + ((plan.paymentsCount - 1) * plan.amount);
                        plan.currency = clonedData.currency;
                        plan.subscriptionIntervalType = window.translatePaymentPlanSubscriptionInterval(plan.subscriptionIntervalType);

                        if (plan.type === 'with_upfront') {
                            plan.paymentsCount -= 1;
                        }
                    });
                }
                return clonedData;
            }
        },
    }
</script>
